export const VIP_PLATFORM = `vip_zju`;
export const STORE_ID = 'bcc92c60-23dd-11ef-a9d3-378389062503';
